const defaultInvStratReview = {
  lastReview: {
    date: '',
  },
  review: {
    type: '',
    specific: {
      reasons: {},
      sectionReasons: {},
      otherReason: {
        hasOtherReason: '',
        otherReasons: [],
        otherReason: '',
      },
      additionalReasons: {},
    },
    normal: {
      hasAcknowledge: false,
    },
  },
  nextReview: {
    type: undefined,
  },
};

export default defaultInvStratReview;
